import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TemplateModalService } from '../modal.service';
import { ConfirmDialogComponent, ConfirmDialogOptions, ConfirmDialogResult } from './confirm-dialog.component';

/**
 * Opens a small confirm dialog. Cancel, Esc, the backdrop and the close
 * button all count as cancel.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly modalService = inject(TemplateModalService);

  /** Emits true once when the user confirms (after `action` succeeds), else false. */
  open(options: ConfirmDialogOptions): Observable<boolean> {
    return this.choose(options).pipe(map((result) => result === 'confirm'));
  }

  /** Like open(), but tells a secondary choice apart from cancel. */
  choose(options: ConfirmDialogOptions): Observable<ConfirmDialogResult> {
    const ref = this.modalService.openComponent(ConfirmDialogComponent, { data: options });
    return ref.afterClosed().pipe(
      map((result) => (result === 'confirm' || result === 'secondary' ? result : 'cancel'))
    );
  }
}
